(function () {
  'use strict';

  /* ---- Mobile menu ---- */
  function initMenu() {
    var toggle = document.querySelector('[data-menu-toggle]');
    var menu = document.querySelector('[data-mobile-menu]');
    if (!toggle || !menu) return;
    toggle.addEventListener('click', function () {
      menu.hidden = !menu.hidden;
      toggle.setAttribute('aria-expanded', String(!menu.hidden));
    });
  }

  /* ---- Cart drawer ---- */
  function initCartDrawer() {
    var drawer = document.querySelector('[data-cart-drawer]');
    if (!drawer) return;
    var openers = document.querySelectorAll('[data-cart-open]');
    var closers = drawer.querySelectorAll('[data-cart-close]');

    function open(e) {
      if (e) e.preventDefault();
      drawer.hidden = false;
      document.body.style.overflow = 'hidden';
      loadCart();
    }
    function close() {
      drawer.hidden = true;
      document.body.style.overflow = '';
    }
    Array.prototype.forEach.call(openers, function (o) { o.addEventListener('click', open); });
    Array.prototype.forEach.call(closers, function (c) { c.addEventListener('click', close); });
    document.addEventListener('keydown', function (e) { if (e.key === 'Escape') close(); });

    function loadCart() {
      var body = drawer.querySelector('[data-cart-drawer-body]');
      if (!body || !window.fetch) return;
      fetch('/cart.js')
        .then(function (r) { return r.json(); })
        .then(function (cart) {
          if (!cart.items || cart.items.length === 0) return;
          var html = '';
          cart.items.forEach(function (item) {
            html += '<div class="cart-item">' +
              (item.image ? '<img class="cart-item__img" src="' + item.image + '" alt="" width="90" height="90" loading="lazy">' : '') +
              '<div><a class="cart-item__name" href="' + item.url + '">' + item.product_title + '</a>' +
              '<span class="cart-item__price">' + (item.quantity) + ' &times; ' + formatMoney(item.final_price) + '</span></div>' +
              '<div class="cart-item__line-total">' + formatMoney(item.final_line_price) + '</div></div>';
          });
          body.innerHTML = html;
        })
        .catch(function () {});
    }
  }

  function formatMoney(cents) {
    return '$' + (cents / 100).toFixed(2);
  }

  /* ---- AJAX add to cart (cards) ---- */
  function initAddForms() {
    var forms = document.querySelectorAll('[data-type="add-to-cart-form"]');
    Array.prototype.forEach.call(forms, function (form) {
      form.addEventListener('submit', function (e) {
        if (!window.fetch) return;
        e.preventDefault();
        var data = new FormData(form);
        fetch('/cart/add.js', { method: 'POST', body: data })
          .then(function () { return fetch('/cart.js'); })
          .then(function (r) { return r.json(); })
          .then(function (cart) {
            var count = document.querySelector('[data-cart-count]');
            if (count) count.textContent = cart.item_count;
            var opener = document.querySelector('[data-cart-open]');
            if (opener) opener.click();
          })
          .catch(function () { form.submit(); });
      });
    });
  }

  /* ---- FAQ accordion (single open) ---- */
  function initFaq() {
    var items = Array.prototype.slice.call(document.querySelectorAll('.faq__item'));
    items.forEach(function (item) {
      item.addEventListener('toggle', function () {
        if (item.open) {
          items.forEach(function (other) {
            if (other !== item && other.parentNode === item.parentNode) other.open = false;
          });
        }
      });
    });
  }

  /* ---- Quantity steppers ---- */
  function initQty() {
    var qtys = document.querySelectorAll('[data-qty]');
    Array.prototype.forEach.call(qtys, function (qty) {
      var input = qty.querySelector('input');
      var dec = qty.querySelector('[data-dec]');
      var inc = qty.querySelector('[data-inc]');
      if (!input) return;
      var min = parseInt(input.getAttribute('min'), 10);
      if (isNaN(min)) min = 1;
      if (dec) dec.addEventListener('click', function () {
        input.value = Math.max(min, (parseInt(input.value, 10) || min) - 1);
      });
      if (inc) inc.addEventListener('click', function () {
        input.value = (parseInt(input.value, 10) || min) + 1;
      });
    });
  }

  /* ---- Product gallery thumbnails ---- */
  function initGallery() {
    var main = document.querySelector('[data-main-img]');
    if (!main) return;
    var thumbs = document.querySelectorAll('[data-thumb]');
    Array.prototype.forEach.call(thumbs, function (thumb) {
      thumb.addEventListener('click', function () {
        var full = thumb.getAttribute('data-full');
        if (full) main.src = full;
      });
    });
  }

  /* ---- Purchase-option toggle (one-time / subscribe) ---- */
  function initPurchase() {
    var groups = document.querySelectorAll('[data-purchase]');
    Array.prototype.forEach.call(groups, function (group) {
      var opts = group.querySelectorAll('.purchase__opt');
      Array.prototype.forEach.call(opts, function (opt) {
        opt.addEventListener('click', function () {
          Array.prototype.forEach.call(opts, function (o) { o.classList.remove('is-active'); });
          opt.classList.add('is-active');
          var radio = opt.querySelector('input[type="radio"]');
          if (radio) radio.checked = true;
        });
      });
    });
  }

  /* ---- Sticky add-to-cart bar ---- */
  function initStickyAtc() {
    var bar = document.querySelector('[data-sticky-atc]');
    if (!bar) return;
    function onScroll() { bar.hidden = !(window.scrollY > 600); }
    window.addEventListener('scroll', onScroll);
    onScroll();
  }

  /* ---- Testimonial marquee pause/play ---- */
  function initMarquee() {
    var roots = document.querySelectorAll('[data-tmq]');
    Array.prototype.forEach.call(roots, function (root) {
      var btn = root.querySelector('[data-tmq-toggle]');
      var label = root.querySelector('[data-tmq-label]');
      if (!btn) return;
      btn.addEventListener('click', function () {
        var paused = root.classList.toggle('is-paused');
        btn.setAttribute('aria-pressed', paused ? 'true' : 'false');
        if (label) label.textContent = paused ? 'Play reviews' : 'Pause reviews';
      });
    });
  }

  function init() {
    initMenu();
    initCartDrawer();
    initAddForms();
    initFaq();
    initQty();
    initGallery();
    initPurchase();
    initStickyAtc();
    initMarquee();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
